import { ScrollReveal } from './ScrollReveal';
import { ArrowRight } from 'lucide-react';
import { useLang } from '@/lib/translations';

export default function WhyItMatters() {
  const { t } = useLang();
  const w = t.whyMatters;
  return (
    <section className="relative py-24 sm:py-32" data-testid="why-it-matters-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <ScrollReveal>
          <div className="overline mb-4">{w.overline}</div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-aurocle-text mb-4">{w.title}</h2>
          <p className="text-base text-aurocle-platinum-muted max-w-2xl mb-16">{w.sub}</p>
        </ScrollReveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-24">
          {w.impacts.map((item, i) => (
            <ScrollReveal key={i} delay={i * 80}>
              <div className="premium-card p-6 h-full" data-testid={`impact-card-${i}`}>
                <div className="relative z-10">
                  <div className="w-8 h-8 flex items-center justify-center border border-aurocle-gold/20 mb-4">
                    <span className="text-xs font-mono text-aurocle-gold">0{i + 1}</span>
                  </div>
                  <h3 className="font-heading text-base font-medium text-aurocle-text mb-2">{item.t}</h3>
                  <p className="text-sm text-aurocle-platinum-muted leading-relaxed">{item.d}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
        <ScrollReveal>
          <div className="text-center mb-8">
            <div className="overline mb-4">{w.modelLabel}</div>
            <h3 className="font-heading text-2xl font-medium text-aurocle-text">{w.modelTitle}</h3>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {w.steps.map((step, i) => (
              <div key={step} className="flex items-center gap-4">
                <div className="px-6 py-3 border border-white/10 hover:border-aurocle-gold/30 transition-colors">
                  <span className="text-xs font-mono text-aurocle-gold/60 block mb-1">0{i + 1}</span>
                  <span className="text-sm font-heading text-aurocle-text">{step}</span>
                </div>
                {i < w.steps.length - 1 && <ArrowRight size={14} className="text-aurocle-gold/30 hidden sm:block" />}
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
